import React, {Component} from 'react'
import {request} from "../../helper/APIUtils";
import {deepCopyObject, hasUserRight, prefixTypeName, showAxiosError} from "../../helper/helper";
import Table from "../../components/Table/Table";
import Select from "../../local_node_modules/react-select"
import {Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import Datetime from "react-datetime/DateTime";
import moment from "moment";
import NoRecordComponent from "../customer/components/NoRecordComponent";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import {EntegratorConf, VirtualHost} from "../../constants";

class PrefixCodeModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            prefixCodesByTypes: [],
            selectedPrefix: null,
            loading: false,
            total: 0,
            page: 0,
            size: 5,
            error: {},
            manual: false,
            selectedType: null,
            nestedModal: false,
            confirmDeleteModal: false,
            keyToShow: null,
            currentPrefix: {
                type: null,
                key: null,
                year: moment().format('YYYY'),
                value: '000000000'
            },
            checkResult: false,
            confirmActivePassiveModal: false,
            activePassiveAction: null,
            loadingProcess: false
        };

        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.listPrefixCodes = this.listPrefixCodes.bind(this);
        this.onSelectType = this.onSelectType.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.onChangeYear = this.onChangeYear.bind(this);
        this.checkIfPrefixKeyExists = this.checkIfPrefixKeyExists.bind(this);
        this.confirmActivePassive = this.confirmActivePassive.bind(this);
        this.handleActivePassive = this.handleActivePassive.bind(this);
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let error = this.state.error;
        let value = e.target.value;
        let documentType = this.state.documentType;
        let result = validateField(rule, boundary, value);
        error = Object.assign(error, {[id]: result});

        if (id === 'tPrefix' &&
            (documentType === 'PrefixCode' || documentType === 'EArsivPrefixCode'
                || documentType === 'DespatchPrefixCode' || documentType === 'ReceiptAdvicePrefixCode')) {
            this.checkIfPrefixKeyExists(e, documentType)
        }
        this.setState({error});
    }

    checkIfPrefixKeyExists(e, documentType) {
        let self = this;
        let error = this.state.error;
        let value = e.target.value;
        let id = e.target.id;
        let result;
        let data = new FormData();
        data.append("value", value);
        data.append("type", documentType);
        self.setState({checkResult: false});
        let params = {
            url: `/prefixCode/findByPrefixKey`,
            data: data,
            method: 'post'
        };
        request(params).then(function (response) {
            if (response.data) {
                result = {valid: false, message: 'Ön Ek başka belgede kullanıldı.'};
                error = Object.assign(error, {[id]: result});
                self.setState({checkResult: true, PrefixCodeError: result, error});
                Alert.error('Ön Ek başka belgede kullanıldı.', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
            }
        })
            .catch(function (error) {
                showAxiosError(error);
                self.setState({checkResult: false});
            });
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    listPrefixCodes(accessor, direction, page, size) {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '';
        let params = {
            url: '/prefixCode/getPrefixCodesByType?page=' + page + '&size=' + size + sortStr,
            method: "post",
            data: this.state.selectedType
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                let prefixCodesByTypes = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    prefixCodesByTypes,
                    loading: false,
                });
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    addPrefix() {
        let self = this;
        let key = this.state.currentPrefix.key;
        let regex = new RegExp(/^[XW]\d{2}/)
        let regexGib = new RegExp(/^GIB/)
        let type = this.state.currentPrefix.type;
        if (((type === "EArsivPrefixCode" || type === "PrefixCode") && key.match(regex) && EntegratorConf.identifier === EntegratorIdentifiers.KOLAYSOFT) || key.match(regexGib)){
            Alert.error("Farklı belge ön eki tanımlayınız.", {
                position: 'top-right',
                effect: 'stackslide',
                html: true,
                timeout: 5000
            });
            this.clearNestedModal();
        } else {
            let params = {
                url: '/prefixCode/addPrefix',
                method: "post",
                data: this.state.currentPrefix
            };
            self.setState({loading: true, manual: self.manual === true ? false : self.manual});
            request(params).then(function (response) {
                self.listPrefixCodes(undefined, undefined, self.state.page, self.state.size);
                let documentType = deepCopyObject(self.state.documentType);
                self.setState({
                    manual: true,
                    nestedModal: false,
                    loading: false,
                    currentPrefix: {
                        type: documentType,
                        key: null,
                        year: moment().format('YYYY'),
                        value: '000000000'
                    }
                });
            }).catch(function (error) {
                self.setState({loading: false});
                showAxiosError(error);
            });
        }
    }

    addPrefixToCustomer() {
        let checkResult = this.state.checkResult;
        let PrefixCodeError = this.state.PrefixCodeError;
        if (checkResult) {
            Alert.error(PrefixCodeError.message, {
                position: 'top-right',
                effect: 'stackslide',
                html: true,
                timeout: 5000
            });
        } else {
            let validity = this.validateComponent();
            if (validity.valid) {
                this.setState({
                    error: {},
                    checkResult: false,
                }, () => this.addPrefix())
            } else {
                Alert.error(this.arrangeErrorMessage(), {
                    position: 'top-right',
                    effect: 'stackslide',
                    html: true,
                    timeout: 5000
                });
            }
        }
    }

    arrangeErrorMessage() {
        let errorObject = deepCopyObject(this.state.error);
        let errorArray = [];
        for (let key in errorObject) {
            if (errorObject.hasOwnProperty(key)) {
                let error = {};
                if (!!errorObject[key].message) {
                    error.field = this.defineReadableFieldName(key);
                    error.message = errorObject[key].message;
                    errorArray.push(error);
                }
            }
        }

        this.setState({error: errorObject});

        return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/>').join('')
    }

    defineReadableFieldName(key) {

        switch (key) {
            case 'tPrefix':
                return 'Ön Ek: ';
            case 'tYear':
                return 'Yıl: ';
            case 'tNo':
                return 'Son Belge Numarası: ';
            default :
                return '';
        }
    }

    handleEdit(item) {
        let keyToShow = item.key + ' ' + item.year;
        this.setState({nestedModal: true, keyToShow, currentPrefix: item});
    }

    handleDelete() {
        let self = this;
        let params = {
            url: '/prefixCode/deletePrefix',
            method: "post",
            data: this.state.selectedPrefix
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params).then(function (response) {
            self.setState({
                manual: true,
                loading: false,
                selectedPrefix: null,
                confirmDeleteModal: false
            });
        })
            .catch(function (error) {
                self.setState({loading: false});
                showAxiosError(error);
            });
    }

    onSelectType(e) {
        this.setState({
            selectedType: e.value,
            documentType: e.value,
            currentPrefix: {
                ...this.state.currentPrefix,
                type: e.value
            }
        }, () => {
            this.listPrefixCodes(undefined, undefined, this.state.page, this.state.size);
        })
    }

    onChangePrefixCode(e) {

        let value = deepCopyObject(e.target.value);

        let regTest = new RegExp(/^[A-Z0-9]{0,3}$/gi).exec(value);

        if (regTest) {
            let str = (e.target.value).toUpperCase();

            this.setState({
                currentPrefix: {
                    ...this.state.currentPrefix,
                    key: str
                }
            }, () => this.preapareKeyToShow())
        } else {
            ////  ToDo: TURKCE KARAKTER GIRILDIGINDE UFAK BIR HATA MESAJI GOSTERILEBILIR !
        }
    }

    confirmDelete(item) {
        this.setState({
            selectedPrefix: item,
            confirmDeleteModal: true
        })
    }

    prepareReadableType(data) {
        switch (data) {
            case 'MVoucherPrefixCode' : {
                return 'Müstahsil Makbuzu';
            }

            case 'SVoucherPrefixCode' : {
                return 'Serbest Meslek Makbuzu';
            }

            case 'ExchangePrefixCode' : {
                return 'E-Döviz Belgeleri';
            }

            case 'PrefixCode' : {
                return 'E-Fatura';
            }

            case 'EArsivPrefixCode' : {
                return 'E-Arşiv';
            }

            case 'DespatchPrefixCode' : {
                return 'E-İrsaliye';
            }

            case 'ReceiptAdvicePrefixCode' : {
                return 'E-İrsaliye Yanıtı';
            }

            case 'ExpenseNotePrefixCode' : {
                return 'E-Gider Pusulası';
            }

            case 'ReceiptPrefixCode' : {
                return 'E-Adisyon Makbuzu';
            }

            case 'SigortaPrefixCode' : {
                return 'E-Sigorta';
            }

            default: {
                return 'Varsayılan Doküman'
            }
        }
    }

    onChangeYear(momentObj) {
        let year = null;

        if (!(typeof momentObj === 'string')) {
            let temp = momentObj.format('YYYY');
            year = moment(temp).format('YYYY');
        } else {
            year = momentObj;
        }

        this.setState({
            currentPrefix: {
                ...this.state.currentPrefix,
                year
            }
        }, () => this.preapareKeyToShow())
    }

    preapareKeyToShow() {
        let prefix = null;
        let suffix = null;

        if (!!this.state.currentPrefix.key) {
            prefix = this.state.currentPrefix.key.toString();
        } else {
            prefix = 'XYZ'
        }

        if (this.state.currentPrefix.year) {
            suffix = this.state.currentPrefix.year.toString();
        } else {
            suffix = moment().format('YYYY');
        }

        let keyToShow = prefix + ' ' + suffix;

        this.setState({keyToShow})
    }

    onChangeValue(e) {

        let value = deepCopyObject(e.target.value);

        let regTest = new RegExp(/^[0-9]{0,9}$/gi).exec(value);

        if (regTest) {
            this.setState({
                currentPrefix: {
                    ...this.state.currentPrefix,
                    value: e.target.value
                }
            })
        }
    }

    clearNestedModal() {
        let documentType = deepCopyObject(this.state.documentType);
        this.setState({
            keyToShow: null,
            error: {},
            checkResult: false,
            currentPrefix: {
                type: documentType,
                key: null,
                year: moment().format('YYYY'),
                value: '000000000'
            }
        })
    }

    cancelNestedModal() {
        let documentType = deepCopyObject(this.state.documentType);
        this.setState({
            nestedModal: false,
            keyToShow: null,
            error: {},
            checkResult: false,
            currentPrefix: {
                type: documentType,
                key: null,
                year: moment().format('YYYY'),
                value: '000000000'
            }
        })
    }

    checkDateValidity(current) {
        let copyCurrent = current.clone();
        return copyCurrent.isBetween(Datetime.moment().subtract(1, 'years'), Datetime.moment().subtract(-1, 'years'));
    }

    confirmActivePassive(item, activePassiveAction) {
        this.setState({
            selectedPrefix: item,
            confirmActivePassiveModal: true,
            activePassiveAction
        })
    }

    handleActivePassive = async () => {
        let self = this;
        if (!!this.state.selectedPrefix) {
            let params = {
                url: '/prefixCode/activePassivePrefix',
                method: "post",
                data: this.state.selectedPrefix
            };
            this.setState({loadingProcess: true});
            try {
                await request(params);
                this.setState({
                    manual: true,
                    selectedPrefix: null,
                    confirmActivePassiveModal: false,
                    activePassiveAction: null,
                    loadingProcess: false
                });
                self.listPrefixCodes(undefined, undefined, self.state.page, self.state.size);
            } catch (error) {
                showAxiosError(error);
            }
            this.setState({loadingProcess: false});
        }
    }

    render() {
        const currentPrefix = deepCopyObject(this.state.currentPrefix);
        const prefixCodesByTypes = deepCopyObject(this.state.prefixCodesByTypes);
        const columns = [
            {
                Header: "Belge Türü",
                title: "Belge Türü",
                accessor: "type",
                Cell: item => (
                    prefixTypeName(item.type)
                )
            },
            {
                Header: "Ön Ek",
                title: "Ön Ek",
                accessor: "key",
            },
            {
                Header: "İşlemler",
                title: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div style={{display: "inline"}}>
                        {(VirtualHost.conf.resourcePrefix !== 'zirve' ||
                                (VirtualHost.conf.resourcePrefix === 'zirve' && this.props.currentUser.impersonate) ||
                                (EntegratorIdentifiers.ZIRVE === this.props.currentUser.vknTckn)) &&
                            <button type="button"
                                    onClick={() => this.handleEdit(item)}
                                    data-toggle="tooltip" data-placement="bottom" title="Düzenle"
                                    style={{
                                        display: "inline",
                                        background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                                    }}
                                    rel="tooltip"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.update, this.props.currentUser)}
                                    className="Btn btn-icon">
                                <i className="BtnIcon far fa-edit "/>
                            </button>
                        }
                        {(VirtualHost.conf.resourcePrefix !== 'zirve' ||
                                (VirtualHost.conf.resourcePrefix === 'zirve' && this.props.currentUser.impersonate) ||
                                (EntegratorIdentifiers.ZIRVE === this.props.currentUser.vknTckn)) &&
                            <button type="button"
                                    onClick={() => this.confirmDelete(item)}
                                    data-toggle="tooltip" data-placement="bottom" title="Sil"
                                    style={{
                                        display: "inline",
                                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
                                    }}
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}
                                    rel="tooltip" className="Btn btn-icon">
                                <i className="BtnIcon far fa-trash-alt"/>
                            </button>
                        }

                        {VirtualHost.conf.resourcePrefix === 'zirve' &&
                            <button type="button"
                                    onClick={() => this.confirmActivePassive(item, item.deletedAt !== null ? "Aktif" : "Pasif")}
                                    data-toggle="tooltip" data-placement="bottom"
                                    title={item.deletedAt !== null ? "Aktif Et" : "Pasif Et"}
                                    style={item.deletedAt !== null ? {
                                        display: "inline",
                                        background: '#3fb0ac'
                                    } : {
                                        display: "inline",
                                        background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'
                                    }}
                                    rel="tooltip" className="Btn  btn-icon"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}>
                                {item.deletedAt !== null ?
                                    <i className="BtnIcon fa fa-check"/>
                                    :
                                    <i className="BtnIcon fas fa-ban"/>
                                }
                            </button>
                        }
                    </div>
                )
            }
        ];
        if (VirtualHost.conf.resourcePrefix === 'zirve') {
            columns.splice(columns.length - 1, 0, {
                    Header: "Aktif/Pasif",
                    title: "Aktif/Pasif",
                    accessor: "deletedAt",
                    Cell: item => (
                        item.deletedAt !== null ? "Pasif" : "Aktif"
                    )
                }
            )
        }
        const types = [
            {value: "MVoucherPrefixCode", label: "Müstahsil Makbuzu"},
            {value: "SVoucherPrefixCode", label: "Serbest Meslek Makbuzu"},
            {value: "ExchangePrefixCode", label: "E-Döviz"},
            {value: 'PrefixCode', label: 'E-Fatura'},
            {value: 'EArsivPrefixCode', label: 'E-Arşiv'},
            {value: 'DespatchPrefixCode', label: 'E-İrsaliye'},
            {value: 'ReceiptAdvicePrefixCode', label: 'E-İrsaliye Yanıtı'},
            {value: 'ExpenseNotePrefixCode', label: 'E-Gider Pusulası'},
            {value: 'ReceiptPrefixCode', label: 'E-Adisyon Makbuzu'},
            {value: 'SigortaPrefixCode', label: 'E-Sigorta'}
        ];
        return (
            <div className="col-12 form-row">
                <div className="col-sm-12 row">
                    <div className="col-md-2">
                        <label className="col-form-label">Belge Türü: </label>
                    </div>
                    <div className="col-sm-10" style={{maxWidth: "none"}}>
                        <div className="form-group">
                            <Select
                                clearable={false}
                                className="select-control"
                                name="type"
                                id="tType"
                                ref="tType"
                                value={this.state.documentType}
                                placeholder="Belge Türü Seçiniz..."
                                options={types}
                                onChange={(e) => this.onSelectType(e)}
                            />
                        </div>
                    </div>
                </div>

                {this.state.prefixCodesByTypes.length !== 0 &&
                    <div className="col-sm-12 ">
                        <nav className="">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{marginBottom: '15px'}}
                                    rel="tooltip" className="TekBtn ekle  btn-icon"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.create, this.props.currentUser)}
                                    onClick={() => this.setState({nestedModal: true})}>
                                Yenİ
                            </button>
                        </nav>

                        <Table
                            columns={columns}
                            content={prefixCodesByTypes}
                            total={this.state.total}
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            page={this.state.page}
                            size={this.state.size}
                            manual={this.state.manual}
                            options={["5", "10", "20", "50", "100"]}
                            fetchData={this.listPrefixCodes}
                        />
                    </div>}

                {(this.state.selectedType !== null && this.state.prefixCodesByTypes.length === 0) &&
                    <div className="col-sm-12 form-row">
                        <nav className="">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        marginBottom: '15px'
                                    }}
                                    rel="tooltip" className="TekBtn ekle  btn-icon"
                                    disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.create, this.props.currentUser)}
                                    onClick={() => this.setState({nestedModal: true})}>
                                Yenİ Tanımla
                            </button>
                        </nav>

                        <NoRecordComponent section="prefix"/>
                    </div>}

                <Modal isOpen={this.state.nestedModal}>
                    <ModalHeader/>
                    <ModalBody>
                        <div>
                            <div className='col-sm-12' style={{marginBottom: '20px', padding: '0 0 0 0'}}>
                                <div className='col-sm-12'>
                                    <label className='col-form-label'>Tipi: </label>
                                </div>

                                <div className='col-sm-12'>
                                    <input className="form-control" type="text" readOnly={true}
                                           value={this.prepareReadableType(this.state.selectedType)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 form-row" style={{padding: '0 0 0 0', margin: '0 0 10px 0'}}>
                                <div className='col-sm-6' style={{padding: '0 0 0 0', margin: '0 0 0 0'}}>
                                    <div className="col-sm-12">
                                        <label className="col-form-label">Ön Ek: </label>
                                    </div>

                                    <div className="col-sm-12">
                                        <div className={"form-group" + this.validateClass('tPrefix')}>
                                            <input className="form-control"
                                                   type="text"
                                                   name="prefix"
                                                   data-vlength="3,3"
                                                   data-vdata="required"
                                                   onBlur={() => this.validateField({
                                                       target: {
                                                           id: "tPrefix",
                                                           dataset: {vdata: "required", vlength: '3,3'},
                                                           value: currentPrefix.key ? currentPrefix.key : ''
                                                       }
                                                   })}
                                                   ref="tPrefix"
                                                   maxLength={3}
                                                   id="tPrefix"
                                                   onChange={(e) => this.onChangePrefixCode(e)}
                                                   value={currentPrefix.key ? currentPrefix.key : ''}/>
                                            {this.validateMessage('tPrefix') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tPrefix"
                                                                     delay={0}>
                                                    {this.validateMessage("tPrefix")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-sm-6' style={{padding: '0 0 0 0', margin: '0 0 0 0'}}>
                                    <div className="col-sm-12">
                                        <label className="col-form-label">Yıl: </label>
                                    </div>

                                    <div className="col-sm-12">
                                        <div className={"form-group" + this.validateClass("tYear")}>
                                            <Datetime
                                                locale='tr'
                                                timeFormat={false}
                                                dateFormat="YYYY"
                                                viewMode='years'
                                                inputProps={{id: 'tYear', vdata: 'year', vlength: '1,255'}}
                                                onBlur={() => this.validateField({
                                                    target: {
                                                        id: "tYear",
                                                        value: currentPrefix.year,
                                                        dataset: {
                                                            vdata: "year",
                                                            vlength: "1,255",
                                                            value: currentPrefix.year
                                                        },
                                                    }
                                                })}
                                                closeOnSelect={true}
                                                ref="tYear"
                                                value={currentPrefix.year}
                                                onChange={(momentObj) => this.onChangeYear(momentObj)}
                                                isValidDate={(current) => this.checkDateValidity(current)}/>
                                            {this.validateMessage('tYear') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tYear"
                                                                     delay={0}>
                                                    {this.validateMessage("tYear")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12" style={{padding: '0 0 0 0'}}>
                                <div className="col-sm-12">
                                    <label className="col-form-label">Son Belge Numarası: ( Örn :
                                        ABC{moment().format('YYYY')}000000000 )</label>
                                </div>

                                <div className="col-sm-12 form-row" style={{padding: '0 5px 0 15px'}}>
                                    <div className='col-4'>
                                        <input className="form-control" type="text" readOnly={true}
                                               value={!this.state.keyToShow ? 'XYZ ' + moment().format('YYYY') : this.state.keyToShow}/>
                                    </div>

                                    <div className='col-8'>
                                        {/*<input className="form-control" type="text" maxLength={9}
											   value={currentPrefix.value}
											   onChange={(e) => this.onChangeValue(e)}/>*/}
                                        <div className={"form-group" + this.validateClass('tNo')}>
                                            <input className="form-control"
                                                   type="text"
                                                   name="no"
                                                   data-vlength="1,9"
                                                   data-vdata="integer"
                                                   ref="tNo"
                                                   maxLength={9}
                                                   id="tNo"
                                                   onChange={(e) => this.onChangeValue(e)}
                                                   value={currentPrefix.value}/>
                                            {this.validateMessage('tNo') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tNo"
                                                                     delay={0}>
                                                    {this.validateMessage("tNo")}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: '#9e9e9e', padding: '11px 43px 11px 8px'}}
                                        rel="tooltip" className="TekBtn vazgec btn-icon"
                                        onClick={() => this.cancelNestedModal()}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6"></div>
                            <div className="col-3">


                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 43px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet "
                                        onClick={() => this.addPrefixToCustomer()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.confirmDeleteModal}>
                    <ModalHeader/>
                    <ModalBody>
                        Silmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row ">
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: '#9e9e9e', padding: '11px 43px 11px 8px'}}
                                        rel="tooltip" className="TekBtn vazgec  btn-icon"
                                        onClick={() => this.setState({
                                            confirmDeleteModal: false,
                                            selectedPrefix: null
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6"></div>
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{padding: '11px 43px 11px 8px'}}
                                        rel="tooltip" className="TekBtn kaydet btn-icon"
                                        onClick={() => this.handleDelete()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.confirmActivePassiveModal}>
                    <ModalHeader/>
                    <ModalBody>
                        {this.state.activePassiveAction} etmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={() => this.setState({
                                            confirmActivePassiveModal: false,
                                            selectedPrefix: null
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-6"></div>

                            <div className="col-3">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        disabled={!hasUserRight(UserRightsEnum.settings.prefixCode.delete, this.props.currentUser)}
                                        onClick={() => this.handleActivePassive()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default PrefixCodeModal;